<template>
  <div class="aboutUs maxWidth">
    <div class="aboutUs-banner">
      <div
        class="enterprise-bannner"
        :style="'background-image:url(' + bannerImg + ')'"
      >
        <div class="enterprise-bannnerBox">
          <span class="edescription">{{ bannerList.alias }}</span>
          <span class="name">{{ bannerList.name }}</span>
          <span class="description">{{ bannerList.description }}</span>
          <button type="button" @click="clickParent">立即咨询</button>
        </div>
      </div>
      <div class="aboutUs-bannerNumber">
        <div class="aboutUs-bannerNumberInner">
          <div
            class="bannerNumberInner-box"
            v-for="(item, index) in processList"
            :key="index"
          >
            <div class="">
              <span>{{ item.number }}</span>
              <span>{{ item.name }}</span>
            </div>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutUs-nav" id="aboutUsNavId">
      <div class="aboutUs-navInner">
        <span
          v-for="(item, index) in navList"
          :key="index"
          :class="{ navActive: navShow == index }"
          @click="navClick(item, index)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <!-- 我们是谁 -->
    <div class="aboutUs-who" id="whoAreWe">
      <div class="aboutUs-whoContent">
        <div class="aboutUs-whoContentTop">
          <img src="../assets/bigTy.png" alt="" />
          <span>{{ whoList.name }}</span>
        </div>
        <div class="aboutUs-whoContentMain">
          <div class="heng"></div>
          <div class="aboutUs-whoContentText">
            <p v-for="(item, index) in whoList.lists" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业文化 -->
    <div class="corporateCulture" id="enterpriseCulture">
      <div class="corporateCulture-inner">
        <div class="corporateCulture-top">
          <img src="../assets/bigTy.png" alt="" />
          <span>{{ corporateCultureList.name }}</span>
          <div class="heng"></div>
        </div>
        <div class="corporateCulture-text">
          <p>{{ corporateCultureList.description }}</p>
        </div>
        <div class="corporateCulture-picList">
          <div
            class="corporateCulture-picListBox"
            v-for="(item, index) in corporateCultureList.lists"
            :key="index"
          >
            <img :src="item.bg" alt="" />
            <div class="picListBox-text">
              <div class="heng"></div>
              <span>{{ item.name }}</span>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的服务 -->
    <div class="ourServices" id="ourServices">
      <div class="ourServices-top">
        <div class="ourServices-topBox">
          <div class="ourServices-topBoxTitle">
            <img src="../assets/bigTy1.png" alt="" />
            <span>{{ ourServicesList.name }}</span>
            <p>
              {{ ourServicesList.description }}
            </p>
          </div>
          <div class="heng"></div>
        </div>
        <div class="ourServices-topList">
          <div
            class="ourServices-topListItem"
            v-for="(item, index) in ourServicesList.lists"
            :key="index"
          >
            <div class="ourServices-topListItemBox">
              <img src="../assets/our-banner.png" alt="" />
              <div class="ourServices-topListItemBottom">
                <div class="heng"></div>
                <span>{{ item.name }}</span>
                <p>{{ item.description }}</p>
              </div>
            </div>
            <div class="ourServices-topListItem1">
              <div class="ourServices-topListItemTop">
                <div class="heng"></div>
                <span>{{ item.name }}</span>
                <p>{{ item.description }}</p>
              </div>
              <div
                class="ourServices-topListItem1-bottom"
                v-for="(itemText, indexText) in item.lists"
                :key="indexText"
              >
                <span>{{ itemText.name }}</span>
                <p>{{ itemText.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ourServices-bottome"></div>
    </div>

    <!-- 软件著作 -->
    <div class="softwareWorks" id="softwareCopyright">
      <div class="softwareWorks-inner">
        <div class="softwareWorks-top">
          <img src="../assets/bigTy.png" alt="" />
          <span>{{ softwareWorksList.name }}</span>
        </div>
        <div class="softwareWorks-main">
          <swiper
            ref="mySwiper"
            :options="swiperOptions"
            @swiper="onSwiper"
            @slideChange="change"
            style="margin-bottom: 30px;"
          >
            <swiper-slide
              v-for="(item, index) in softwareWorksList.lists"
              :key="index"
            >
              <div class="developItem">
                <div
                  style="display:flex;flex-direction:column;text-align: center;"
                >
                  <span v-if="swiperIndex == index">{{ item.name }}</span>
                  <img :src="item.img" />
                  <div v-if="swiperIndex == index" class="heng"></div>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 立即咨询 -->
    <div class="consultingService" id="contactUs">
      <div class="consultingService-top">
        <span> 立即获取适合您的互联网智能化解决方案</span>
        <div class="photo">
          <span>可直接拨打电话</span>
          <span style="color:#E1251A">186-3037-6696</span>
        </div>
      </div>
      <div class="consultingService-form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="公司名称：" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请填写您的公司名称或负责人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请填写您的联系方式："
            ></el-input>
          </el-form-item>
          <el-form-item label="咨询主题：" prop="theme">
            <el-input
              v-model="ruleForm.theme"
              placeholder="请填写您的咨询主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作邮箱：">
            <el-input
              v-model="ruleForm.email"
              placeholder="请填写您的邮箱地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="咨询内容：">
            <el-input
              type="textarea"
              v-model="ruleForm.content"
              placeholder="请填写您要咨询的具体内容"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <button type="button" @click="submitForm('ruleForm')">
              立即咨询
            </button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import ZXDialog from "../components/ZXDialog.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import "swiper/css/swiper.css";
export default {
  name: "aboutUs",
  components: {
    Swiper,
    SwiperSlide,
    ZXDialog
  },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      bannerList: {},
      bannerImg: "",
      whoList: {},
      processList: [],
      corporateCultureList: {},
      ourServicesList: {},
      softwareWorksList: {},
      workTitle: "",
      navList: [],
      active: 0,
      hengShow: false,
      swiperIndex: 0,

      swiperOptions: {
        initialSlide: 0,
        width: outerWidth * 0.13,
        spaceBetween: 5,
        watchSlidesProgress: true,
        loopedSlides: 5,
        loop: true,
        // autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          // type: "progressbar",
          // type: "custom",

          renderBullet: function(index, className) {
            return '<div class="' + className + '">' + (index + 1) + "</div>";
          },
          clickable: true
        },
        on: {
          progress: function(progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              // console.log(slide);
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = Math.abs(slideProgress) - 1 + 1;
              }
              var translate =
                modify +
                slideProgress * 25 * (Math.abs(slideProgress) - 1 + 1) +
                window.innerWidth * 0.5 -
                outerWidth * 0.2 +
                "px";
              var scale = Math.abs(slideProgress) > 0.2 ? 0.7 : 1;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );

              slide.css("zIndex", zIndex);
              slide.css("transformOrigin", "50% 100%");
              slide.css("opacity", 1);
              if (modify > 2.5) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      },
      navShow: 0,
      news: [],
      ruleForm: {
        name: "",
        phone: "",
        theme: "",
        email: "",
        content: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写您的公司名称或负责人名称",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请填写您的联系方式：", trigger: "blur" },
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请填写正确的手机号"
          }
        ],
        theme: [
          { required: true, message: "请填写您的咨询主题", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    swiperIndex(val) {
      // console.log(val);
      // console.log(this.news[parseInt(val)]);
      // this.workTitle = this.news[parseInt(val)].text;
    }
  },
  mounted() {},
  created() {
    this.getList();
    this.getScroll();
  },
  methods: {
    getScroll() {
      window.onscroll = function() {
        //变量t是滚动条滚动时，距离顶部的距离
        var t = document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(t);
        var scrollup = document.getElementById("aboutUsNavId");
        if (scrollup) {
          if (t > 1027) {
            scrollup.style.cssText = "position: fixed;top: 0; margin-top:0;";
          } else {
            scrollup.style.cssText =
              "position: relative;top: unset;margin-top: 195px;";
          }
        }
        //当滚动到距离顶部200px时，返回顶部的锚点显示
      };
    },
    getList() {
      this.$axios.get("index/common/about").then(res => {
        if (res.status == 200) {
          // console.log(res.data.data);
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.processList = res.data.data["02"];
          this.navList = res.data.data["03"];
          this.whoList = res.data.data["04"];
          this.corporateCultureList = res.data.data["05"];
          this.ourServicesList = res.data.data["06"];
          this.softwareWorksList = res.data.data["07"];
          // console.log(this.ourServicesList);
        }
      });
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    },
    navClick(item, index) {
      this.navShow = index;
      location.href = item.url;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post("index/common/add_consult", this.ruleForm)
            .then(res => {
              // console.log(res.status);
              if (res.status == 200) {
                this.ruleForm = {};
                // console.log(res.data.msg);
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onSwiper(e) {
      console.log(e);
    },
    change(e) {
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.realIndex;
      // console.log(this.$refs.mySwiper.swiperInstance);
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.aboutUs {
  margin: 0 auto;
  width: 1920px;
}
.aboutUs-banner {
  margin-top: 70px;
  position: relative;
}
.enterprise-bannner {
  height: 737px;
  /* background-image: url("~../../assets/qy-banner.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}
.enterprise-bannnerBox {
  position: absolute;
  top: 149px;
  left: 311px;
  display: flex;
  flex-direction: column;
}
.enterprise-bannnerBox .edescription {
  font-size: 76px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: rgba(69, 70, 71, 0.3);
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.enterprise-bannnerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.enterprise-bannnerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}

.enterprise-bannnerBox button {
  cursor: pointer;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.aboutUs-banner .aboutUs-bannerBox > img {
  display: block;
  width: 100%;
  height: 879px;
}
.aboutUs-banner .aboutUs-bannerBox > button {
  position: absolute;
  top: 534px;
  left: 320px;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.aboutUs-bannerNumber {
  background-color: #fff;
  position: absolute;
  bottom: -197px;
  width: 100%;
}
.aboutUs-bannerNumberInner {
  width: 1280px;
  height: 240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.bannerNumberInner-box {
  width: 320px;
  padding: 64px 0 60px;
  border-right: 1px solid #454647;
  text-align: center;
}
.bannerNumberInner-box:last-child {
  border-right: 0;
}
.bannerNumberInner-box > div span:first-child {
  font-size: 76px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #454647;
  margin-bottom: 40px;
}
.bannerNumberInner-box > div span:last-child {
  font-size: 26px;
}
.bannerNumberInner-box > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #595959;
  white-space: nowrap;
}
.aboutUs-nav {
  width: 1920px;
  z-index: 9999;

  height: 100px;
  background: #1a1a1a;
}
.aboutUs-navInner {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.aboutUs-navInner span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  padding: 37px 88px;
  white-space: nowrap;
  cursor: pointer;
}
.aboutUs-navInner .navActive {
  background: linear-gradient(90deg, #dc3939, #ff4242);
}
/* 我们是谁 */
.aboutUs-who {
  padding-top: 105px;
  padding-right: 320px;
  height: 772px;
  background-image: url("~../assets/who-banner.png");
  background-repeat: no-repeat;
  /* background-size: cover; */
  position: relative;
  display: flex;
  justify-content: end;
}
.aboutUs-whoContent {
  width: 722px;
  /* text-align: center; */
}
.aboutUs-whoContentTop {
  text-align: center;
  position: relative;
  margin-bottom: 27px;
}
.aboutUs-whoContentTop > img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: 264px;
}
.aboutUs-whoContentTop > span {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
}
.aboutUs-whoContentMain .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 42px;
}
.aboutUs-whoContentText {
  display: flex;
  flex-direction: column;
}
.aboutUs-whoContentText > p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  text-indent: 30px;
  margin-bottom: 60px;
}
/* 企业文化 */
.corporateCulture {
  position: relative;
  padding-top: 164px;
  margin-bottom: 100px;
  background-image: url("~../assets/corporateCulture-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.corporateCulture-inner {
  width: 1440px;
  margin: 0 auto;
}
.corporateCulture-top {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 41px;
  padding-left: 82px;
}
.corporateCulture-top > img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: 70px;
}
.corporateCulture-top > span {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
  margin-bottom: 27px;
}
.corporateCulture-top > .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
}
.corporateCulture-text {
  padding: 0 82px;
  margin-bottom: 64px;
}
.corporateCulture-text > p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  text-indent: 35px;
  line-height: 40px;
}
.corporateCulture-picList {
  width: 1440px;
  margin: 0 auto;
  display: flex;
}
.corporateCulture-picListBox {
  width: 360px;
  height: 478px;
  position: relative;
  cursor: pointer;
}
.corporateCulture-picListBox > img {
  display: block;
  width: 360px;
  height: 478px;
}

.corporateCulture-picListBox .picListBox-text {
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  position: absolute;
  top: 312px;
}
.corporateCulture-picListBox:hover .picListBox-text {
  top: 32px;
}
.corporateCulture-picListBox .picListBox-text .heng {
  width: 40px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 14px;
}
.corporateCulture-picListBox .picListBox-text span {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  display: block;
  margin-bottom: 15px;
}
.corporateCulture-picListBox .picListBox-text p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 26px;
}
/* 我们的服务 */
.ourServices {
}
.ourServices-top {
  height: 518px;
  background-image: url("~../assets/ourServices-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.ourServices-topBox {
  width: 1280px;
  margin: 0 auto;
  padding-top: 97px;
  margin-bottom: 46px;
}
.ourServices-topBoxTitle {
  position: relative;
  margin-bottom: 27px;
  display: flex;
  align-items: center;
}
.ourServices-topBox .heng {
  width: 70px;
  height: 3px;
  background: #ffffff;
}
.ourServices-topBoxTitle img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: -14px;
}
.ourServices-topBoxTitle > span {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  display: block;
  margin-right: 44px;
}
.ourServices-topBoxTitle > p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.ourServices-topList {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.ourServices-topListItem:hover .ourServices-topListItemBox {
  display: none;
}
.ourServices-topListItem:hover .ourServices-topListItem1 {
  display: block;
}
.ourServices-topListItemBox {
  width: 410px;
  height: 420px;
  background: #ffffff;
  cursor: pointer;
}
.ourServices-topListItemBox {
}
.ourServices-topListItem img {
  display: block;
  width: 100%;
  height: 231px;
  margin-bottom: 15px;
}
.ourServices-topListItemBottom {
  padding: 0 40px;
}
.ourServices-topListItemBottom .heng {
  width: 40px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 14px;
}
.ourServices-topListItemBottom > span {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 15px;
}
.ourServices-topListItemBottom > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #454647;
  line-height: 26px;
}

.ourServices-topListItem1 {
  width: 410px;
  height: 420px;
  background: #ffffff;
  position: relative;
  background-image: url("~../assets/our-banner1.png");
  background-repeat: no-repeat;
  background-size: 410px 231px;
  padding-top: 40px;
  display: none;
  cursor: pointer;
}

.ourServices-topListItemTop {
  padding: 0 40px;
  margin-bottom: 32px;
}
.ourServices-topListItemTop .heng {
  width: 40px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 14px;
}
.ourServices-topListItemTop > span {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 15px;
}
.ourServices-topListItemTop > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #454647;
  line-height: 26px;
}
.ourServices-bottome {
  width: 100%;
  height: 170px;
  background: #f6fafb;
  border: 1px solid #ffffff;
}
.ourServices-topListItem1-bottom {
  padding: 0 40px;
  margin-bottom: 20px;
}
.ourServices-topListItem1-bottom > span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  line-height: 32px;

  background: linear-gradient(0deg, #dc3939 0%, #ff4242 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ourServices-topListItem1-bottom > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.ourServices-topListItem1-bottom:last-child {
  margin-bottom: 0;
}
/* 软件著作 */

.softwareWorks {
  width: 1920px;
  margin: 0 auto;
}
.softwareWorks-inner {
  width: 1280px;
  margin: 0 auto;
  padding-top: 69px;
  margin-bottom: 70px;
}
.softwareWorks-top {
  text-align: center;
  position: relative;
  margin-bottom: 69px;
}
.softwareWorks-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: 540px;
}
.softwareWorks-top span {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
}
.softwareWorks-main {
  position: relative;
  border-top: 1px solid rgba(214, 219, 221, 0.4);
  /* overflow: hidden; */
}
.developItem {
  display: flex;
  justify-content: center;
}
.developItem > div > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #df3a3a;
  margin-bottom: 44px;
}
.developItem .heng {
  width: 136px;
  height: 3px;
  background: #df3a3a;
  margin: 0 auto;
  /* display: none; */
}
.developItem > img {
  display: block;
  width: 220px;
  height: 300px;
}
.developItemNum {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 6px solid rgba(197, 209, 218, 0.1);
  border-radius: 50%;
  line-height: 14px;
  text-align: center;
  margin: 0 auto;
}
.developItemNum > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
}
.developItemNumActive {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 6px solid rgba(255, 66, 66, 0.1);
  border-radius: 50%;
}

.developItemNumActive > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff4242;
}
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  height: 74px;
  top: -13px;
  display: flex;
  justify-content: space-around;
  padding: 0 97px;
}
.softwareWorks-main >>> .swiper-wrapper {
  align-items: end;
}
.softwareWorks-main >>> .swiper-pagination-clickable .swiper-pagination-bullet {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 1px solid rgba(197, 209, 218, 1);
  box-shadow: 0px 0px 10px rgba(197, 209, 218, 0.3);
  border-radius: 50%;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
}
.softwareWorks-main >>> .swiper-container {
  padding-top: 37px;
  overflow: unset;
  width: 1480px;
  /* overflow: hidden; */
  position: relative;
  left: -135px;
}
.swiper-button-prev,
.swiper-button-next {
  top: 0;
  width: 48px;
  height: 48px;
  background: #c9ced2;
  border-radius: 24px;
}
.swiper-button-next:hover {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.swiper-button-prev:hover {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.swiper-button-prev:before {
  display: block;
  content: " ";
  background-image: url("~../assets/jt-left.png");
  background-size: contain;
  width: 0.8rem;
  height: 1rem;
  background-repeat: no-repeat;
}
.swiper-button-prev:after {
  content: " ";
}
.swiper-button-next:before {
  display: block;
  content: " ";
  background-image: url("~../assets/jt-right.png");
  background-size: contain;
  width: 0.8rem;
  height: 1rem;
  background-repeat: no-repeat;
}

.swiper-button-next:after {
  content: " ";
}
.softwareWorks-main
  >>> .swiper-pagination-clickable
  .swiper-pagination-bullet-active {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff4242;
  line-height: 22px;
  background: #007aff;
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 1px solid rgba(255, 66, 66, 0.3);
  box-shadow: 0px 0px 10px rgba(255, 66, 66, 0.3);
  border-radius: 50%;
}
/* 联系我们 */
.consultingService {
  /* height: 664px; */
  background-image: url("~../assets/consultingService-banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 79px;
  padding-bottom: 45px;
}
.consultingService-top {
  width: 1280px;
  margin: 0 auto;
  margin-bottom: 57px;
}
.consultingService-top > span {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #00000c;
  display: block;
  margin-bottom: 15px;
}
.consultingService-top > .photo > span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #454647;
}
.consultingService-form {
  width: 1280px;
  margin: 0 auto;
}
.consultingService-form .el-form {
  display: flex;
  flex-wrap: wrap;
}
.consultingService-form .el-form .el-form-item {
  width: 47.5%;
  margin-right: 30px;
}
.consultingService-form .el-form .el-form-item:nth-child(2n) {
  margin-right: 0px;
}
.consultingService-form .el-form .el-form-item:nth-child(5) {
  width: 100%;
}
.consultingService-form .el-form .el-form-item:nth-child(6) {
  width: 100px;
  margin: 0 auto;
}
.consultingService-form .el-form .el-form-item:nth-child(6) button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  margin-top: 38px;
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue